import ls from '../../../../services/ls'
import * as types from './mutation-types'

export const user = (state) => {
    return state.user != null
    ? state.user
    : ls.getObject(types.SET_USER)
}
